<script type="text/javascript">
    import {get, writable} from "svelte/store";
    import PortsStore from "./Store";
    import LoadState from "../../Enums/LoadState";

    import Textfield, {Input, Textarea} from "@smui/textfield";

    export let input = writable("");
    export let selected = writable(null);
    export let limit = -1;
    export let locodePorts = [];
    export let disabled = false;

    let inputBeforeSelected = "";

    $: {
        locodePorts = PortsStore.helpers.searchByLocode($input, limit);
    }
</script>



{#if $selected === null}
    <Textfield dense fullwidth variant="filled" bind:value={$input} disabled={disabled} style="background-color:#eee;" /><br/>

    {#if $input.length > 0}
        {#if locodePorts.length > 0}
            {#each locodePorts as port}
                <div class='oa' style="padding:6px;border-bottom:1px solid #eee;" on:click={()=>{ 
                    $selected = port; 
                    inputBeforeSelected = $input;
                    $input = port.locode;
                }}>
                    <div class='fl' style="width:100px;font-weight:bold;">{port.locode}:</div>
                    <div>{port.name}</div>
                </div>
            {/each}
        {/if}
    {/if}
{:else}

    <div class='oa' style="padding:6px;border:1px solid #eee;border-radius:3px;">
        <div class='fl' style="width:100px;font-weight:bold;padding:4px;">{$selected.locode}:</div>
        <div class='fl' style="padding:4px;">{$selected.name}</div>
        <div class='fr'>
            <button class='btn btn-sm bg-error' on:click={()=>{ 
                $input = inputBeforeSelected;
                $selected = null;
                inputBeforeSelected = "";
            }}>Clear</button>
        </div>
    </div>

{/if}